import type { TechniqueEntry } from '../schema';

export const amplifiedReflectionDescent: TechniqueEntry = {
  key: 'amplified_reflection_descent',
  version: '0.1',
  name: 'Amplified reflection descent',
  pillar: 'MI',
  serves:
    "Getting beneath any stated feeling or surface answer, one layer at a time (the generic descent move) when what the member has named is a doorway, not the bottom. (The technique in the base doc's Sunday-dread worked example.)",
  method: [
    'Alternate question and reflection; never stack questions.',
    "Descend with one question, composed fresh in the member's vocabulary, then catch the next layer with an amplified reflection: restate what they said slightly stronger and slightly more specific than they put it, so they correct toward precision.",
    'The correction is the descent: a reflection invites them to correct or extend, which goes deeper than interrogation ever does; a run of near-identical digging questions turns the exercise into a quiz.',
    'Coach stance throughout: propose and wonder aloud rather than assert, and never state an interpretation as fact.',
    'No turn target; move only when a layer is genuinely complete.',
  ],
  never: [
    'Never keep laddering on a member gone flat or two-word; route to compress-and-close.',
    'Never state interpretations as fact.',
    {
      constraint: 'Never use this banned reflective hedge (or any other).',
      phrase: 'it sounds like',
    },
    'No change-steering mid-descent.',
  ],
  requiresFirst: [
    {
      kind: 'conversation',
      clause: 'Member engaged and still bringing material.',
    },
  ],
  doneWhen:
    'The member lands somewhere true beneath the stated feeling: names what it is actually about in their own words with an affect shift (slowing, going quiet, "huh", self-correction, emotion), or circles the same underlying thing twice in different words.',
  firstMove: null,
  exemplars: [],
  appliesTo: ['base', 'journey'],
  programs: null,
  signature: null,
  source:
    'shared/sections/practice_objective.md (Movement A mechanics, generalised), practice_guidelines.md (reflection-deepens-better rules)',
};
